// Only OpenDental supports insurance writeback currently, if more PMS support it in future, add them here
export const supportedPMSForInsuranceWriteback = ['opendental'];

// PMS that support document center writeback
export const documentCenterSupportedPMS = ['eaglesoft18', 'opendental', 'dentrix'];
